import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';

const All7Emirates = () => {
  const navigate = useNavigate();
  const [activeEmirate, setActiveEmirate] = useState('Dubai');
  const [priceFilter, setPriceFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');

  const emirates = [
    {
      name: 'Dubai', flag: '🏙️', color: '#00D4FF',
      stats: { avgPrice: 'AED 1.8M', pricePerSqft: 'AED 1,650', yoy: '+18.2%', yield: '6–8%', transactions: '180K+' },
      description: 'Global property hub with world-class infrastructure, tax-free income, and the highest transaction volumes in the UAE.',
      highlights: ['Largest freehold market', 'DLD regulated', 'Golden Visa eligible', 'Strong expat demand'],
      topAreas: ['Downtown Dubai', 'Dubai Marina', 'Palm Jumeirah', 'Business Bay', 'JVC', 'Dubai Hills'],
      propertyTypes: ['Apartments', 'Villas', 'Townhouses', 'Penthouses', 'Off-Plan'],
      investmentProfile: 'High Growth + High Yield',
      reraStatus: 'Full RERA Regulation',
    },
    {
      name: 'Abu Dhabi', flag: '🕌', color: '#00D4FF',
      stats: { avgPrice: 'AED 1.4M', pricePerSqft: 'AED 1,200', yoy: '+13.5%', yield: '5–7%', transactions: '45K+' },
      description: 'UAE capital with luxury island developments, cultural landmarks, and a growing expat-friendly freehold market.',
      highlights: ['Capital city stability', 'Luxury island projects', 'Cultural hub', 'Government-backed developers'],
      topAreas: ['Yas Island', 'Saadiyat Island', 'Al Reem Island', 'Al Maryah Island', 'Masdar City'],
      propertyTypes: ['Apartments', 'Villas', 'Townhouses', 'Off-Plan'],
      investmentProfile: 'Stable Growth + Good Yield',
      reraStatus: 'ADREC Regulated',
    },
    {
      name: 'Sharjah', flag: '🏛️', color: '#00FF88',
      stats: { avgPrice: 'AED 650K', pricePerSqft: 'AED 650', yoy: '+8.5%', yield: '7–9%', transactions: '22K+' },
      description: 'Family-friendly emirate with affordable property prices and high rental yields. Close proximity to Dubai.',
      highlights: ['Most affordable near Dubai', 'High rental yields', 'Family-oriented', 'Cultural heritage'],
      topAreas: ['Al Majaz', 'Al Nahda', 'Muwaileh', 'Al Khan', 'Aljada'],
      propertyTypes: ['Apartments', 'Villas', 'Studios'],
      investmentProfile: 'Affordable + High Yield',
      reraStatus: 'SRERD Regulated',
    },
    {
      name: 'Ajman', flag: '🌊', color: '#00FF88',
      stats: { avgPrice: 'AED 380K', pricePerSqft: 'AED 420', yoy: '+6.2%', yield: '8–10%', transactions: '8K+' },
      description: 'Smallest emirate with the most affordable property prices in the UAE. Ideal for budget investors seeking high yields.',
      highlights: ['Lowest entry prices in UAE', 'Highest rental yields', 'Freehold for all nationalities', 'Corniche waterfront'],
      topAreas: ['Ajman Corniche', 'Al Nuaimiya', 'Al Rashidiya', 'Emirates City'],
      propertyTypes: ['Apartments', 'Studios', 'Villas'],
      investmentProfile: 'Budget Entry + Highest Yield',
      reraStatus: 'ARRA Regulated',
    },
    {
      name: 'Ras Al Khaimah', flag: '⛰️', color: '#FFC800',
      stats: { avgPrice: 'AED 850K', pricePerSqft: 'AED 780', yoy: '+24.5%', yield: '6–8%', transactions: '12K+' },
      description: 'Fastest growing emirate with Wynn Resort development driving massive investment interest. Mountain and beach living.',
      highlights: ['Fastest growing market', 'Wynn Resort catalyst', 'Mountain & beach living', 'Tourism boom'],
      topAreas: ['Al Marjan Island', 'Mina Al Arab', 'Al Hamra Village', 'Hayat Island'],
      propertyTypes: ['Apartments', 'Villas', 'Resort Properties', 'Off-Plan'],
      investmentProfile: 'Highest Growth Potential',
      reraStatus: 'RERA RAK Regulated',
    },
    {
      name: 'Fujairah', flag: '🌿', color: '#6B9EC4',
      stats: { avgPrice: 'AED 480K', pricePerSqft: 'AED 520', yoy: '+5.8%', yield: '6–7%', transactions: '4K+' },
      description: 'East coast emirate with scenic mountain and ocean views. Emerging market with affordable prices and peaceful living.',
      highlights: ['East coast location', 'Mountain & ocean views', 'Peaceful lifestyle', 'Affordable prices'],
      topAreas: ['Fujairah City', 'Dibba', 'Khor Fakkan', 'Kalba'],
      propertyTypes: ['Villas', 'Apartments', 'Townhouses'],
      investmentProfile: 'Emerging Market',
      reraStatus: 'FMD Regulated',
    },
    {
      name: 'Umm Al Quwain', flag: '🦅', color: '#6B9EC4',
      stats: { avgPrice: 'AED 280K', pricePerSqft: 'AED 320', yoy: '+4.1%', yield: '7–8%', transactions: '2K+' },
      description: 'Smallest and most affordable emirate. Emerging investment destination with low-cost entry and development potential.',
      highlights: ['Lowest prices in UAE', 'Development potential', 'Quiet lifestyle', 'Waterfront properties'],
      topAreas: ['UAQ Marina', 'Al Salamah', 'Al Raas', 'Falaj Al Mualla'],
      propertyTypes: ['Villas', 'Apartments', 'Land'],
      investmentProfile: 'Lowest Cost Entry',
      reraStatus: 'UAQ Municipality',
    },
  ];

  const activeEmirateData = emirates?.find(e => e?.name === activeEmirate);

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #020B18 0%, #041428 50%, #020B18 100%)' }}>
      {/* Header */}
      <div className="sticky top-0 z-50 px-4 py-3" style={{ background: 'rgba(2, 11, 24, 0.95)', borderBottom: '1px solid rgba(0, 212, 255, 0.15)', backdropFilter: 'blur(12px)' }}>
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 transition-opacity hover:opacity-80">
            <Icon name="ArrowLeft" size={18} color="#00D4FF" />
            <span className="text-sm" style={{ color: '#00D4FF' }}>Back to Home</span>
          </button>
          <div className="flex items-center gap-2">
            <span className="text-lg">🇦🇪</span>
            <span className="font-bold text-sm md:text-base" style={{ color: '#E8F4FF', fontFamily: "'Orbitron', sans-serif" }}>All 7 Emirates Coverage</span>
          </div>
          <button onClick={() => navigate('/search-results?location=UAE')} className="px-4 py-2 rounded-lg text-sm font-semibold" style={{ background: 'linear-gradient(135deg, #00D4FF, #0099CC)', color: '#000' }}>Search UAE</button>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12">
        {/* Hero */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-4" style={{ background: 'rgba(0, 212, 255, 0.1)', border: '1px solid rgba(0, 212, 255, 0.3)', color: '#00D4FF' }}>
            <span>🇦🇪</span>
            <span>COMPLETE UAE MARKET COVERAGE</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold mb-4" style={{ fontFamily: "'Orbitron', sans-serif" }}>
            <span style={{ color: '#00D4FF' }}>All 7 Emirates</span>
            <span style={{ color: '#E8F4FF' }}> Coverage</span>
          </h1>
          <p className="text-base md:text-lg max-w-2xl mx-auto" style={{ color: '#6B9EC4' }}>Complete market intelligence across all UAE emirates — from Dubai's luxury towers to Umm Al Quwain's emerging waterfront developments.</p>
        </div>

        {/* Emirates Selector */}
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2 mb-8">
          {emirates?.map((emirate) => (
            <button
              key={emirate?.name}
              onClick={() => setActiveEmirate(emirate?.name)}
              className="p-3 rounded-xl text-center transition-all duration-200"
              style={activeEmirate === emirate?.name
                ? { background: 'rgba(0, 212, 255, 0.2)', border: '2px solid rgba(0, 212, 255, 0.7)', boxShadow: '0 0 15px rgba(0, 212, 255, 0.3)' }
                : { background: 'rgba(10, 22, 40, 0.8)', border: '1px solid rgba(0, 212, 255, 0.15)' }
              }
            >
              <div className="text-2xl mb-1">{emirate?.flag}</div>
              <div className="text-xs font-medium" style={{ color: activeEmirate === emirate?.name ? '#00D4FF' : '#6B9EC4' }}>{emirate?.name}</div>
            </button>
          ))}
        </div>

        {/* Active Emirate Detail */}
        {activeEmirateData && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
            {/* Main Info */}
            <div className="lg:col-span-2 p-6 md:p-8 rounded-2xl" style={{ background: 'rgba(10, 22, 40, 0.9)', border: '1px solid rgba(0, 212, 255, 0.25)' }}>
              <div className="flex items-start justify-between mb-4">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-4xl">{activeEmirateData?.flag}</span>
                    <div>
                      <h2 className="text-2xl font-bold" style={{ color: '#E8F4FF' }}>{activeEmirateData?.name}</h2>
                      <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: 'rgba(0, 212, 255, 0.1)', color: '#00D4FF', border: '1px solid rgba(0, 212, 255, 0.2)' }}>{activeEmirateData?.reraStatus}</span>
                    </div>
                  </div>
                  <p className="text-sm" style={{ color: '#6B9EC4' }}>{activeEmirateData?.description}</p>
                </div>
              </div>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
                {Object.entries(activeEmirateData?.stats)?.map(([key, val]) => (
                  <div key={key} className="p-3 rounded-xl text-center" style={{ background: 'rgba(0, 212, 255, 0.05)', border: '1px solid rgba(0, 212, 255, 0.12)' }}>
                    <div className="text-sm font-bold" style={{ color: '#00D4FF', fontFamily: "'JetBrains Mono', monospace" }}>{val}</div>
                    <div className="text-xs mt-0.5" style={{ color: '#4A7A9B' }}>{key === 'avgPrice' ? 'Avg Price' : key === 'pricePerSqft' ? 'Per Sqft' : key === 'yoy' ? 'YoY Growth' : key === 'yield' ? 'Rental Yield' : 'Transactions'}</div>
                  </div>
                ))}
              </div>

              {/* Highlights */}
              <div className="mb-4">
                <div className="text-sm font-semibold mb-2" style={{ color: '#E8F4FF' }}>Key Highlights</div>
                <div className="grid grid-cols-2 gap-2">
                  {activeEmirateData?.highlights?.map((h, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <Icon name="CheckCircle" size={14} color="#00D4FF" />
                      <span className="text-sm" style={{ color: '#6B9EC4' }}>{h}</span>
                    </div>
                  ))}
                </div>
              </div>

              <button
                onClick={() => navigate(`/search-results?location=${encodeURIComponent(activeEmirateData?.name)}`)}
                className="w-full py-3 rounded-xl font-semibold text-sm transition-all duration-200"
                style={{ background: 'linear-gradient(135deg, #00D4FF, #0099CC)', color: '#000' }}
              >
                Search Properties in {activeEmirateData?.name} →
              </button>
            </div>

            {/* Side Panel */}
            <div className="space-y-4">
              <div className="p-5 rounded-2xl" style={{ background: 'rgba(10, 22, 40, 0.9)', border: '1px solid rgba(0, 212, 255, 0.2)' }}>
                <h3 className="font-bold text-sm mb-3" style={{ color: '#E8F4FF' }}>Top Areas</h3>
                <div className="space-y-2">
                  {activeEmirateData?.topAreas?.map((area, i) => (
                    <button
                      key={i}
                      onClick={() => navigate(`/search-results?location=${encodeURIComponent(area)}`)}
                      className="w-full flex items-center justify-between p-2.5 rounded-lg transition-all duration-200"
                      style={{ background: 'rgba(0, 212, 255, 0.04)', border: '1px solid rgba(0, 212, 255, 0.1)' }}
                      onMouseEnter={e => { e.currentTarget.style.background = 'rgba(0, 212, 255, 0.1)'; e.currentTarget.style.border = '1px solid rgba(0, 212, 255, 0.3)'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = 'rgba(0, 212, 255, 0.04)'; e.currentTarget.style.border = '1px solid rgba(0, 212, 255, 0.1)'; }}
                    >
                      <span className="text-sm" style={{ color: '#6B9EC4' }}>{area}</span>
                      <Icon name="ArrowRight" size={12} color="#00D4FF" />
                    </button>
                  ))}
                </div>
              </div>

              <div className="p-5 rounded-2xl" style={{ background: 'rgba(10, 22, 40, 0.9)', border: '1px solid rgba(0, 212, 255, 0.2)' }}>
                <h3 className="font-bold text-sm mb-3" style={{ color: '#E8F4FF' }}>Property Types</h3>
                <div className="flex flex-wrap gap-2">
                  {activeEmirateData?.propertyTypes?.map((type, i) => (
                    <span key={i} className="px-3 py-1 rounded-full text-xs" style={{ background: 'rgba(0, 212, 255, 0.08)', border: '1px solid rgba(0, 212, 255, 0.2)', color: '#00D4FF' }}>{type}</span>
                  ))}
                </div>
                <div className="mt-4 p-3 rounded-xl" style={{ background: 'rgba(0, 212, 255, 0.06)', border: '1px solid rgba(0, 212, 255, 0.15)' }}>
                  <div className="text-xs font-semibold mb-1" style={{ color: '#00D4FF' }}>Investment Profile</div>
                  <div className="text-sm" style={{ color: '#E8F4FF' }}>{activeEmirateData?.investmentProfile}</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* All Emirates Comparison Table */}
        <div className="p-6 md:p-8 rounded-2xl mb-8" style={{ background: 'rgba(10, 22, 40, 0.9)', border: '1px solid rgba(0, 212, 255, 0.2)' }}>
          <h2 className="text-xl font-bold mb-6" style={{ color: '#E8F4FF' }}>Emirates Comparison</h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr style={{ borderBottom: '1px solid rgba(0, 212, 255, 0.15)' }}>
                  {['Emirate', 'Avg Price', 'Price/Sqft', 'YoY Growth', 'Rental Yield', 'Investment Profile']?.map(h => (
                    <th key={h} className="text-left py-3 px-3 text-xs font-semibold" style={{ color: '#6B9EC4' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {emirates?.map((emirate, idx) => (
                  <tr
                    key={idx}
                    onClick={() => setActiveEmirate(emirate?.name)}
                    className="cursor-pointer transition-all duration-200"
                    style={{ borderBottom: '1px solid rgba(0, 212, 255, 0.08)', background: activeEmirate === emirate?.name ? 'rgba(0, 212, 255, 0.06)' : 'transparent' }}
                    onMouseEnter={e => { if (activeEmirate !== emirate?.name) e.currentTarget.style.background = 'rgba(0, 212, 255, 0.03)'; }}
                    onMouseLeave={e => { if (activeEmirate !== emirate?.name) e.currentTarget.style.background = 'transparent'; }}
                  >
                    <td className="py-3 px-3">
                      <div className="flex items-center gap-2">
                        <span>{emirate?.flag}</span>
                        <span className="text-sm font-medium" style={{ color: '#E8F4FF' }}>{emirate?.name}</span>
                      </div>
                    </td>
                    <td className="py-3 px-3 text-sm" style={{ color: '#00D4FF', fontFamily: "'JetBrains Mono', monospace" }}>{emirate?.stats?.avgPrice}</td>
                    <td className="py-3 px-3 text-sm" style={{ color: '#6B9EC4' }}>{emirate?.stats?.pricePerSqft}</td>
                    <td className="py-3 px-3 text-sm font-bold" style={{ color: '#00FF88' }}>{emirate?.stats?.yoy}</td>
                    <td className="py-3 px-3 text-sm" style={{ color: '#6B9EC4' }}>{emirate?.stats?.yield}</td>
                    <td className="py-3 px-3 text-xs" style={{ color: '#6B9EC4' }}>{emirate?.investmentProfile}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center p-8 rounded-2xl" style={{ background: 'rgba(10, 22, 40, 0.9)', border: '1px solid rgba(0, 212, 255, 0.2)' }}>
          <h2 className="text-xl font-bold mb-3" style={{ color: '#E8F4FF' }}>Explore All UAE Properties</h2>
          <p className="text-sm mb-6" style={{ color: '#6B9EC4' }}>Search across all 7 emirates with RERA compliance data and live market insights</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <button onClick={() => navigate('/search-results?location=UAE')} className="px-8 py-3 rounded-xl font-semibold text-sm" style={{ background: 'linear-gradient(135deg, #00D4FF, #0099CC)', color: '#000', boxShadow: '0 0 20px rgba(0, 212, 255, 0.4)' }}>Search All UAE →</button>
            <button onClick={() => navigate('/rera-compliance-intelligence')} className="px-8 py-3 rounded-xl font-semibold text-sm" style={{ background: 'transparent', border: '2px solid rgba(0, 212, 255, 0.5)', color: '#00D4FF' }}>RERA Compliance →</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default All7Emirates;